import { Controller } from "@hotwired/stimulus"

// Live-enables/disables the Submit button as required answers are filled in.
// Attached to the answers form; the Submit button lives OUTSIDE the form (so it
// can't PATCH answers), so we reach it by id. The button is server-rendered with
// the correct initial `disabled` state for no-JS; this keeps it live as you type.
//
// Each required field's .form-group carries data-submit-gate-target="requiredGroup".
export default class extends Controller {
  static targets = ["requiredGroup"]

  connect() {
    this.handler = () => this.refresh()
    this.element.addEventListener("input", this.handler)
    this.element.addEventListener("change", this.handler)
    this.refresh()
  }

  disconnect() {
    this.element.removeEventListener("input", this.handler)
    this.element.removeEventListener("change", this.handler)
  }

  refresh() {
    const button = document.getElementById("submit-form-btn")
    if (!button) return
    button.disabled = !this.requiredGroupTargets.every((group) => this.filled(group))
  }

  // "Filled" per field type: a radio/checkbox group needs a selection; a
  // text/number/select/textarea needs a non-blank value.
  filled(group) {
    const radios = group.querySelectorAll('input[type="radio"]')
    if (radios.length) return Array.from(radios).some((r) => r.checked)

    const checkbox = group.querySelector('input[type="checkbox"]')
    if (checkbox) return checkbox.checked

    // Skip the hidden `id` input every .form-group carries (it always has a
    // value) — otherwise every group would always look "filled".
    const field = group.querySelector('input:not([type="hidden"]), select, textarea')
    return field ? field.value.trim() !== "" : true
  }
}
